"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPaypalDetailsResponseMapper = void 0;
var GetPaypalDetailsResponseMapper = /** @class */ (function () {
    function GetPaypalDetailsResponseMapper(data) {
        this.localData = data;
    }
    GetPaypalDetailsResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return GetPaypalDetailsResponseMapper;
}());
exports.GetPaypalDetailsResponseMapper = GetPaypalDetailsResponseMapper;
//# sourceMappingURL=GetPaypalDetailsResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/GetPaypalDetailsResponseMapper.js
// module id = 2210
// module chunks = 8